import React from 'react';
import { Helmet } from 'react-helmet-async';
interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  ogImage?: string;
  ogType?: string;
  canonical?: string;
}
export function SEO({
  title = 'Justus Kraft - CRM Experte | Vertriebs-Automatisierung',
  description = 'Mit 16 Jahren mein erstes Gewerbe gegründet. Heute, mit 23 Jahren, helfe ich Unternehmen, ihren Vertrieb durch intelligente CRM-Systeme zu verdoppeln. 110+ zufriedene Kunden.',
  keywords = 'CRM, Vertrieb, Automatisierung, CRM Kraft, Justus Kraft, Vertriebsoptimierung, B2B, B2C, CRM Beratung',
  ogImage = 'https://cdn.magicpatterns.com/uploads/jWaCxaLsc32b7Nk2LkzDn3/62dfd10966fa026013ebcbcf_565aa1ce-min-p-1600_(3).jpg',
  ogType = 'website',
  canonical
}: SEOProps) {
  const siteUrl = typeof window !== 'undefined' ? window.location.origin : 'https://crm-kraft.de';
  const currentUrl = typeof window !== 'undefined' ? window.location.href : siteUrl;
  const canonicalUrl = canonical || currentUrl;
  const faviconUrl = 'https://cdn.magicpatterns.com/uploads/2DZbG6C862o1ffwWtZP92V/facicon-jk-144.png';
  return <Helmet data-id="element-225" data-mp="24jxnn7dvi839">
      {/* Primary Meta Tags */}
      <title data-id="element-226" data-mp="1zk1hp2lm86l2">{title}</title>
      <meta name="title" content={title} data-id="element-227" data-mp="1zji8caa16qin" />
      <meta name="description" content={description} data-id="element-228" data-mp="1zme9s8l37xbu" />
      <meta name="keywords" content={keywords} data-id="element-229" data-mp="1um024rneepec" />

      {/* Language */}
      <html lang="de" data-id="element-230" data-mp="1qjd42904w88p" />

      {/* Favicon - Multiple sizes for different contexts */}
      <link rel="icon" type="image/png" sizes="16x16" href={faviconUrl} data-id="element-231" data-mp="1lswq8nseiklt" />
      <link rel="icon" type="image/png" sizes="32x32" href={faviconUrl} data-id="element-232" data-mp="1lrln8q6s5gvr" />
      <link rel="icon" type="image/png" sizes="144x144" href={faviconUrl} data-id="element-233" data-mp="1gulged23wa3l" />
      <link rel="shortcut icon" href={faviconUrl} data-id="element-234" data-mp="1bv8r7lnriqxu" />

      {/* Apple Touch Icon */}
      <link rel="apple-touch-icon" sizes="180x180" href={faviconUrl} data-id="element-235" data-mp="16ve4lub0snil" />

      {/* Android/Chrome */}
      <link rel="icon" type="image/png" sizes="192x192" href={faviconUrl} data-id="element-236" data-mp="12uap58wvwthw" />

      {/* Windows Tile */}
      <meta name="msapplication-TileImage" content={faviconUrl} data-id="element-237" data-mp="s8fec2nwfz5g" />
      <meta name="msapplication-TileColor" content="#0A0E27" data-id="element-238" data-mp="sb1ma3epcgo7" />

      {/* Theme Color */}
      <meta name="theme-color" content="#0A0E27" data-id="element-239" data-mp="x9bdy417wz52" />

      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} data-id="element-240" data-mp="j9k4mglnc6xe" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} data-id="element-241" data-mp="o8d9jkmvaply" />
      <meta property="og:url" content={currentUrl} data-id="element-242" data-mp="o96i8r5dzp6q" />
      <meta property="og:title" content={title} data-id="element-243" data-mp="1by7n64f0gi79" />
      <meta property="og:description" content={description} data-id="element-244" data-mp="1fyi2i7op0kys" />
      <meta property="og:image" content={ogImage} data-id="element-245" data-mp="1fy00svj9hejh" />
      <meta property="og:locale" content="de_DE" data-id="element-246" data-mp="127d233di3one" />
      <meta property="og:site_name" content="CRM Kraft" data-id="element-247" data-mp="126utr8dkdjz4" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" data-id="element-248" data-mp="174woiqkcr7qf" />
      <meta property="twitter:url" content={currentUrl} data-id="element-249" data-mp="1uv8u3us4ksdu" />
      <meta property="twitter:title" content={title} data-id="element-250" data-mp="1utpco0uqgbah" />
      <meta property="twitter:description" content={description} data-id="element-251" data-mp="1zmqsqc6oegvn" />
      <meta property="twitter:image" content={ogImage} data-id="element-252" data-mp="291aqqkl9f7x4" />

      {/* Additional Meta Tags */}
      <meta name="robots" content="index, follow" data-id="element-253" data-mp="28yy4hv8gybe9" />
      <meta name="author" content="Justus Kraft" data-id="element-254" data-mp="24yxmy1q2pk2z" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" data-id="element-255" data-mp="2ir42bllejn1d" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" data-id="element-256" data-mp="2it849xzqqbz0" />

      {/* Structured Data - Person/Organization */}
      <script type="application/ld+json" data-id="element-257" data-mp="1q26lzo0r40b9">
        {JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Person',
        name: 'Justus Kraft',
        jobTitle: 'CRM Experte',
        description: 'CRM-Berater und Vertriebs-Automatisierer mit IT- und Vertriebshintergrund',
        url: siteUrl,
        image: ogImage,
        sameAs: [
          // Add social media profiles here when available
        ],
        knowsAbout: ['CRM-Systeme', 'Vertriebsautomatisierung', 'B2B Vertrieb', 'B2C Vertrieb', 'IT-Entwicklung'],
        alumniOf: {
          '@type': 'EducationalOrganization',
          name: 'Selbstständiger Unternehmer seit 16 Jahren'
        }
      })}
      </script>

      {/* Structured Data - Service */}
      <script type="application/ld+json" data-id="element-258" data-mp="1pzv5r5wxx6z5">
        {JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Service',
        serviceType: 'CRM Beratung und Automatisierung',
        provider: {
          '@type': 'Person',
          name: 'Justus Kraft'
        },
        areaServed: {
          '@type': 'Country',
          name: 'Deutschland'
        },
        description: 'Professionelle CRM-Beratung und Vertriebsautomatisierung für Unternehmen. Kombination aus IT-Expertise und Vertriebserfahrung.',
        offers: {
          '@type': 'Offer',
          availability: 'https://schema.org/InStock',
          price: '0',
          priceCurrency: 'EUR',
          description: 'Kostenlose Erstberatung'
        }
      })}
      </script>
    </Helmet>;
}